/**
 * API: Reporte de Eficiencia Terminal (Administración del Sistema).
 *
 * Endpoint: GET /api/escolar/reportes/eficiencia-terminal/
 *
 * Filtros soportados:
 *  - ciclo_ingreso (req)
 *  - id_campus     (opc)
 *  - id_seccion    (opc)
 *  - id_programa   (opc)
 *  - page          (opc, default 1)
 *  - page_size     (opc, default 15)
 *  - all           (opc, '1' devuelve todos sin paginar)
 */

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

function getAuthToken() {
  return localStorage.getItem('authToken');
}

function getHeaders() {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

/**
 * @param {Object} params
 * @param {number|string} params.ciclo_ingreso
 * @param {number|string} [params.id_campus]
 * @param {number|string} [params.id_seccion]
 * @param {number|string} [params.id_programa]
 * @param {number}        [params.page=1]
 * @param {number}        [params.page_size=15]
 * @param {boolean}       [params.all=false]
 * @returns {Promise<{page:number,page_size:number,total:number,total_pages:number,filtros:object,resultados:Array}>}
 */
export async function getReporteEficienciaTerminal({
  ciclo_ingreso,
  id_campus,
  id_seccion,
  id_programa,
  page = 1,
  page_size = 15,
  all = false,
} = {}) {
  if (!ciclo_ingreso) {
    throw new Error("El parámetro 'ciclo_ingreso' es requerido.");
  }

  const qs = new URLSearchParams();
  qs.set('ciclo_ingreso', String(ciclo_ingreso));
  if (id_campus !== undefined && id_campus !== null && id_campus !== '' && id_campus !== 'todos') {
    qs.set('id_campus', String(id_campus));
  }
  if (id_seccion !== undefined && id_seccion !== null && id_seccion !== '' && id_seccion !== 'todos') {
    qs.set('id_seccion', String(id_seccion));
  }
  if (id_programa !== undefined && id_programa !== null && id_programa !== '' && id_programa !== 'todos') {
    qs.set('id_programa', String(id_programa));
  }
  if (all) {
    qs.set('all', '1');
  } else {
    qs.set('page', String(page));
    qs.set('page_size', String(page_size));
  }

  const url = `${API_BASE}/escolar/reportes/eficiencia-terminal/?${qs.toString()}`;
  const res = await fetch(url, { headers: getHeaders(), cache: 'no-store' });

  if (!res.ok) {
    let errorMsg = `Error ${res.status} al obtener el reporte`;
    try {
      const body = await res.json();
      if (body && body.error) errorMsg = body.error;
    } catch (_) {
      /* respuesta sin cuerpo JSON */
    }
    throw new Error(errorMsg);
  }

  return res.json();
}

export default getReporteEficienciaTerminal;
